import api from './Api';
import type { Category as CategoryType } from '../types/Product';

export interface ProductType {
  id: number;
  name: string;
}

// Re-export Category type from types folder
export type Category = CategoryType;

export const CategoryApi = {
  // Get all categories
  getAll: () =>
    api.get<Category[]>('/categories'),

  // Create category
  create: (name: string) =>
    api.post<Category>('/categories', { name }),

  // Update category
  update: (id: number, name: string) =>
    api.put<Category>(`/categories/${id}`, { name }),

  // Delete category
  delete: (id: number) =>
    api.delete(`/categories/${id}`),
};

export const ProductTypeApi = {
  // Get all product types
  getAll: () =>
    api.get<ProductType[]>('/product-types'),

  // Create product type
  create: (name: string) =>
    api.post<ProductType>('/product-types', { name }),

  // Update product type
  update: (id: number, name: string) =>
    api.put<ProductType>(`/product-types/${id}`, { name }),

  // Delete product type
  delete: (id: number) =>
    api.delete(`/product-types/${id}`),
};
